import React, { FunctionComponent } from 'react';
import PdfIcon from '../../../../../presentational/icons/PdfIcon';

const BrochureIcon: FunctionComponent = () => {
  return <PdfIcon />;
};

export default BrochureIcon;
